/* ShonenSports : l'option « Nom personnalisé » est liée à son maillot (propriété _maillot = variante). Si le maillot quitte le panier, l'option part avec. */
(function(){
  var OPTION_HANDLES = ['nom-personnalise'];
  var busy = false, timer = null;
  function sync(){
    if(busy) return; busy = true;
    fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(cart){
      var items = cart.items || [];
      var orphans = items.filter(function(it){
        if(OPTION_HANDLES.indexOf(it.handle) < 0) return false;
        var linked = it.properties && it.properties._maillot;
        if(linked){ return !items.some(function(j){ return String(j.variant_id) === String(linked) && j.quantity > 0; }); }
        return !items.some(function(j){ return OPTION_HANDLES.indexOf(j.handle) < 0 && j.properties && j.properties['Nom']; });
      });
      if(!orphans.length){ busy = false; return; }
      var updates = {}; orphans.forEach(function(it){ updates[it.key] = 0; });
      return fetch('/cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({updates: updates})})
        .then(function(){ busy = false; location.reload(); });
    }).catch(function(){ busy = false; });
  }
  function schedule(){ clearTimeout(timer); timer = setTimeout(sync, 400); }
  var _fetch = window.fetch;
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if(/\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)) p.then(function(){ schedule(); }, function(){});
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, url){ if(/\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(String(url))) this.addEventListener('loadend', schedule); return _open.apply(this, arguments); };
  document.addEventListener('submit', function(e){ var f = e.target; if(f && /\/cart\/(change|update)/.test(f.getAttribute('action') || '')) setTimeout(schedule, 800); }, true);
  if(document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
})();
